import React from 'react';
import { browserHistory } from 'react-router';

import { Button, Space, Tag } from 'antd';
import { InboxOutlined, CopyOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, colors } from '@yuhuinc/ui-library';
import moment from 'moment';

import { getTranslatedString } from 'helpers/i18n';

export default function PackageList({ applicationPackages, loading, archiveApplicationPackage }) {
  const toNewPackage = () => {
    browserHistory.push('/companies/application_packages/new');
  };

  // Published templates are not editable
  const onClickTemplate = (applicationPackage) => {
    browserHistory.push(`/companies/application_packages/${applicationPackage.id}/edit`);
  };

  const columns = [
    {
      title: getTranslatedString('landlordPortal.applicationPackages.name'),
      dataIndex: 'name',
      searchable: true,
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => (
        <Button
          type="text"
          onClick={() => {
            onClickTemplate(record);
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: getTranslatedString('common.status'),
      dataIndex: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
      render: (status) => (
        <Tag color={colors.TAG_STATUS_COLORS[status]}>
          {getTranslatedString(`landlordPortal.applicationTemplate.${status}`)}
        </Tag>
      ),
    },
    {
      title: getTranslatedString('landlordPortal.applicationPackages.lastModified'),
      dataIndex: 'updated_at',
      sorter: true,
      render: (updated_at) => moment(updated_at).format('YYYY-MM-DD'),
    },
    {
      title: getTranslatedString('landlordPortal.applicationPackages.applications'),
      dataIndex: 'applications_count',
    },
    {
      title: getTranslatedString('landlordPortal.applicationPackages.actions'),
      key: 'action',
      render: (applicationPackage) => (
        <Space>
          <Button
            type="link"
            icon={<InboxOutlined />}
            onClick={() => archiveApplicationPackage(applicationPackage)}
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      actionButtonLabel={getTranslatedString('landlordPortal.applicationPackages.addPackage')}
      actionButtonOnClick={toNewPackage}
      showActionButton
      dataSource={applicationPackages}
      columns={columns}
      loading={loading}
      pagination={{
        total: applicationPackages.length,
        hideOnSinglePage: true,
        size: 'small',
      }}
      resetButtonOnClick={() => {}}
      title={getTranslatedString('landlordPortal.applicationPackages.packages')}
      scroll={{ x: false }}
    />
  );
}
